// /dashboard/:orgSlug/billing — Figma frame 19 plan & billing (33:2399).
// Owner: screens-commerce, US-140.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { PlanBillingScreen } from "../screens/commerce/PlanBillingScreen";

export const billingRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/billing",
  staticData: { title: "Plan & billing" },
  component: BillingRoute,
});

function BillingRoute() {
  const { orgSlug } = billingRoute.useParams();
  return (
    <PlanBillingScreen orgSlug={orgSlug} />
  );
}
